/**
 * 
 * @param insideDiameterOfTheRimAtNippleSeat field 2a
 * @param innerDiameterOfTheRim field 2b
 * @param rimFloorHeight field 2c
 * @param isTopActive check if field 2a is active
 * @returns 
 */
const findERD = (
  insideDiameterOfTheRimAtNippleSeat:number,
  innerDiameterOfTheRim:number,
  rimFloorHeight:number,
  isTopActive:boolean,
) => {

  if (isTopActive) {
    return insideDiameterOfTheRimAtNippleSeat;
  }
  return innerDiameterOfTheRim + (2 * rimFloorHeight)
};

/**
 * 
 * @param insideDiameterOfTheRimAtNippleSeat field 2a
 * @param innerDiameterOfTheRim field 2b
 * @param rimFloorHeight field 2c
 * @param isTopActive check if field 2a is active
 * @param spokeHoleDiameter field 5
 * @param erdDimensionDistanceLeft field 3a
 * @param pitchCircleDiameterLeft field 4a
 * @param pitchCircleDiameterRight field 4b
 * @param desiredCrossoversLeft field 6b
 * @param wheelSpokeHoles field 6a
 * @param desiredCrossoversRight field 6c
 * @param erdDimensionDistanceRight field 3b
 * @returns 
 */
export const spokeLength = (
  insideDiameterOfTheRimAtNippleSeat:number,
  innerDiameterOfTheRim:number,
  rimFloorHeight:number,
  isTopActive:boolean,
  spokeHoleDiameter:number,
  erdDimensionDistanceLeft:number,
  pitchCircleDiameterLeft:number,
  pitchCircleDiameterRight:number,
  desiredCrossoversLeft:number,
  wheelSpokeHoles:number,
  desiredCrossoversRight:number,
  erdDimensionDistanceRight:number
) => {
  const field2a = insideDiameterOfTheRimAtNippleSeat;
  const field2b = innerDiameterOfTheRim;
  const field2c = rimFloorHeight;
  const field5 = spokeHoleDiameter;
  const field3a = erdDimensionDistanceLeft;
  const field4a = pitchCircleDiameterLeft;
  const field4b = pitchCircleDiameterRight;
  const field6b = desiredCrossoversLeft;
  const field6a = wheelSpokeHoles;
  const field6c = desiredCrossoversRight;
  const field3b = erdDimensionDistanceRight;

  const ERD = findERD(
    field2a,
    field2b,
    field2c,
    isTopActive,
  );

  let L1 = 0;
  let L2 = 0;

  if (field6b) {
    L1 = Math.sqrt(field3a**2 + (ERD**2 + field4a**2 - 2 * field2a * field4a * Math.cos(2 * Math.PI * field6b / field6a)) / 4) - (field5 / 2)
  }

  if (field6b === 0) {
    L1 = Math.sqrt((field3a)^2 + (ERD / 2 - (field4a) / 2)**2) - (field5 / 2);
  }

  if (field6c) {
    L2 = Math.sqrt(field3a**2 + (field2a**2 + field4b**2 - 2 * field2a * field4b * Math.cos(2 * Math.PI * field6c / field6a)) / 4) - (field5 / 2)
  }

  if (field6c == 0) {
    L2 =  Math.sqrt((field3b)**2 + (ERD / 2 - (field4b) / 2)**2) - ((field5) / 2)
  }

  return {
    L1, L2
  }

}